export default "__VITE_ASSET__B1H_3Z_3__"